import axios from "axios";
import env from "../variables/EndpointEnvironment";
const headers = {
  "Content-Language": localStorage.getItem('i18nextLng'),
}
const CorporateGovernanceAPI = (props) => {
 
  return axios.get(
    `${env.HOST}/tata-kelola-perusahaan/${props}`,
    {
      headers
    }
  );
};
export default CorporateGovernanceAPI;
